import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.999 8.667a.503.503 0 0 1-.518-.512V3.697l-1.6 1.582a.47.47 0 0 1-.35.142.53.53 0 0 1-.37-.147A.5.5 0 0 1 3 4.907q0-.206.16-.364l2.396-2.368A.57.57 0 0 1 5.993 2q.124 0 .236.04a.6.6 0 0 1 .207.135L8.848 4.56q.154.152.152.353a.5.5 0 0 1-.163.36.55.55 0 0 1-.363.153.49.49 0 0 1-.364-.154L6.517 3.697v4.464q0 .216-.15.36A.5.5 0 0 1 6 8.667M9.771 13.96a.7.7 0 0 0 .468 0 .6.6 0 0 0 .205-.135l2.395-2.367a.5.5 0 0 0 .161-.365.5.5 0 0 0-.16-.367.53.53 0 0 0-.371-.147.47.47 0 0 0-.35.142l-1.6 1.582V7.845A.504.504 0 0 0 10 7.333a.5.5 0 0 0-.369.146.48.48 0 0 0-.149.36v4.464L7.89 10.728a.49.49 0 0 0-.364-.154.55.55 0 0 0-.363.152.5.5 0 0 0-.163.361.48.48 0 0 0 .152.353l2.412 2.385a.6.6 0 0 0 .207.135"
	})
});
export default SvgSort;
